import { render } from "./NcrmCompanySmtpAccountsTable.vue?vue&type=template&id=c6763ef8&scoped=true"
import script from "./NcrmCompanySmtpAccountsTable.vue?vue&type=script&lang=js"
export * from "./NcrmCompanySmtpAccountsTable.vue?vue&type=script&lang=js"

import "./NcrmCompanySmtpAccountsTable.vue?vue&type=style&index=0&id=c6763ef8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6763ef8"]])

export default __exports__